import { AxiosPromise } from 'axios'
import { ICategory, ICategoryPayload } from '@src/types/category.types'
import createAxiosInstance, { createOptimizedAPI } from '.'

interface ICategoriesApi {
  getCategories(): AxiosPromise<{items: ICategory[]}>;
  getCategory(id: number): AxiosPromise<ICategory>;
  createCategory(category: ICategoryPayload): AxiosPromise<void>;
  updateCategory(category: ICategory): AxiosPromise<void>;
  deleteCategory(id: number): AxiosPromise<void>;
}

const api = createAxiosInstance()

const categoriesApi: ICategoriesApi = {
  getCategories(): AxiosPromise<{items: ICategory[]}> {
    return api.get('categories')
  },
  getCategory(id): AxiosPromise<ICategory> {
    return api.get(`categories/${id}`)
  },
  createCategory(category): AxiosPromise<void> {
    return api.post('categories', category)
  },
  updateCategory(category): AxiosPromise<void> {
    return api.put(`categories/${category.id}`, category)
  },
  deleteCategory(id): AxiosPromise<void> {
    return api.delete(`categories/${id}`)
  }
}

export default {
  ...categoriesApi,
  ...createOptimizedAPI(categoriesApi)
}
